module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step2_Image7.81320fa8.jpg";